<template>
    <v-card class="expense-card">
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar.snackbar">
            {{ callbackResponse.message }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <div class="sticky-toolbar">
            <v-toolbar class="toolbar" color="indigo" dark>
                <v-toolbar-title>
                    Add Expenses
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialogueClose" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </div>
        <span style="color: green">REMAINING BUDGET : {{validAmount}}  </span> <br />
        <span style="color: red"> {{validMsg}}</span> 
        <v-container>
            <v-row>
                <v-col cols="12" md="6">
                    <v-autocomplete v-model="expenses.subsectionID"
                                    required
                                    dense
                                    outlined
                                    :items="subsectionList"
                                    clearable
                                    single-line
                                    item-text="value"
                                    item-value="id"
                                    @change="subsectionChanged">
                        <template v-slot:label>
                            <span :style="{ color: radioColors[index] }">{{ $t('subSectionName') }}</span>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete v-model="expenses.monthID"
                                    required
                                    dense
                                    outlined
                                    :items="monthList"
                                    label="Select Month"
                                    clearable
                                    single-line
                                    item-text="id"
                                    item-value="value"></v-autocomplete>
                    <v-text-field label="Amount"
                                  v-model="expenses.amount"
                                  dense
                                  outlined
                                  type="number"
                                  @input="amountChangevalidation"
                                  required></v-text-field>
                </v-col>

                <v-col cols="12" md="6" style=" padding-top: 0px;">
                    <div class="radio-group" style=" padding-left: 8rem; padding-top: 0px;">
                        <v-radio-group v-model="expenses.workingStatus" :mandatory="false">
                            <v-radio v-for="(status, index) in workStatusList"
                                     :key="status.value"
                                     :value="status.value"
                                     :style="{ color: radioColors[index] }"
                                     class="custom-radio">
                                <template v-slot:label>
                                    <span :style="{ color: radioColors[index] }">{{ status.id }}</span>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </div>
                </v-col>
            </v-row>
            <v-textarea label="Remarks"
                        v-model="expenses.remarks"
                        dense
                        outlined
                        class="custom-textarea"></v-textarea>
        </v-container>
        <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn class="custom-save-button" v-if="this.isvalidtoexpense==true" @click="submit">Submit</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'AddComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                    errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                    errors.push("Year is required.");
                return errors;
            },
        },
        props: ['addData'],
        components: {},
        data() {
            return {
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                expenses: {
                    monthID: "4",
                    amount: 0,
                    remarks: "",
                    workingStatus: "1",
                    companyID: 0,
                    branchID: 0,
                    depoID: 0,
                    subsectionID:0,
                },
                table: false,
                dialogCreate: false,
                monthList: [],
                subsectionList: [],
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                tableFormData: [],
                snackbar: {
                    snackbar: false,
                    dateMenu: false,
                    servicesData: {
                        data: {},
                        message: "",
                        color: ""
                    },
                },
                helpData: [],
                radioColors: ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0'],
                logData: this.$route.query,
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                workStatusList: [],
                color: "",
                validAmount:0,
                isvalidtoexpense:false,
                validMsg:""
            };
        },
        validations: {
            logData: {
                companyID: { required },
                year: { required },
            }
        },
        mounted() {
            this.loadData();
        },

        methods: {
            dialogueClose() {
                this.expenses = {
                    monthID: "4",
                    amount: 0,
                    remarks: "",
                    workingStatus: "1",
                    companyID: 0,
                    branchID: 0,
                    subsectionID: 0,
                    depoID: 0,
                }
                this.isvalidtoexpense = false;
                this.validMsg = "";
                this.validAmount = 0;
                this.$emit("formResponse", this.servicesData);
            },
            getRadioRippleColor(index) {
                const rippleColors = ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0']; // Add more colors if needed
                return rippleColors[index % rippleColors.length];
            },
            loadData() {
                axios.get('ReportSettings/GetYearMonthsList').then(response => {
                    this.monthList = response.data
                })
                axios.get('ReportSettings/GetWorkStatusList').then(response => {
                    this.workStatusList = response.data
                })
                this.getsubsectionmappinglist()
                
            },
            getsubsectionmappinglist() {
                let param = {
                    ReportID: parseInt(this.addData.reportID),
                    FiscalYearID: parseInt(this.addData.yearID),
                    companyID: 0,
                    branchID: null,
                    depoID: null,

                }
                axios.post("ReportSettings/DDLSubSectionMapping", param).then(response => {
                        this.subsectionList = response.data
                });
            },
            submit() {

                let param = {
                    reportID: parseInt(this.addData.reportID),
                    fiscalYearID: parseInt(this.addData.yearID),
                    monthID: parseInt(this.expenses.monthID),
                    amount: parseInt(this.expenses.amount),
                    remarks: this.expenses.remarks,
                    subsectionID: parseInt(this.expenses.subsectionID),
                    workStatusID: parseInt(this.expenses.workingStatus),
                    companyID: 0,
                    branchID: null,
                    depoID: null,

                }
                axios.post("ReportSettings/OfficeExpensesInsertOrUpdateDataAsync", param).then(response => {
                    console.log('check', response)
                    if (response.data.success) {
                        this.snackbar.servicesData.data = response.data
                        this.snackbar.servicesData.message = "Office Expenses added Successfully"
                        this.snackbar.servicesData.color = "success"
                        this.dialogueClose()
                    }
                }).catch(response => {
                    this.snackbar.servicesData.data = response.data
                    this.snackbar.servicesData.message = "Error Adding Office Expenses, Please Contact Admin"
                    this.snackbar.servicesData.color = "error"
                });
            },
            subsectionChanged(newValue) {
                let param = {
                    reportID: parseInt(this.addData.reportID),
                    fiscalYearID: parseInt(this.addData.yearID),
                    monthID: parseInt(this.expenses.monthID),
                    amount: parseInt(this.expenses.amount),
                    remarks: this.expenses.remarks,
                    subsectionID: parseInt(newValue),
                    workStatusID: parseInt(this.expenses.workingStatus),
                    companyID: 0,
                    branchID: null,
                    depoID: null,

                }
                axios.post("ReportSettings/OfficeExpensesValidationAsync", param).then(response => {
                        this.validAmount = response.data.amount
                    if (parseInt(this.expenses.amount) <= this.validAmount)
                    {
                        this.isvalidtoexpense = true;
                        this.validMsg= ""
                        
                    }
                    else
                    {
                        this.isvalidtoexpense = false;
                        this.validMsg = "You have a less availabe budget."
                    }
                }).catch(response => {
                    console.log(response)
                    if (parseInt(this.expenses.amount) <= this.validAmount) {
                        this.isvalidtoexpense = true;
                        this.validMsg = ""

                    }
                    else {
                        this.isvalidtoexpense = false;
                        this.validMsg = "You have a less availabe budget."

                    }
                });
            },
            amountChangevalidation() {
                let param = {
                    reportID: parseInt(this.addData.reportID),
                    fiscalYearID: parseInt(this.addData.yearID),
                    monthID: parseInt(this.expenses.monthID),
                    amount: parseInt(this.expenses.amount),
                    remarks: this.expenses.remarks,
                    subsectionID: parseInt(this.expenses.subsectionID),
                    workStatusID: parseInt(this.expenses.workingStatus),
                    companyID: 0,
                    branchID: null,
                    depoID: null,

                }
                axios.post("ReportSettings/OfficeExpensesValidationAsync", param).then(response => {
                    this.validAmount = response.data.amount
                    if (parseInt(this.expenses.amount) <= this.validAmount) {
                        this.isvalidtoexpense = true;
                        this.validMsg = ""
                    }
                    else {
                        this.isvalidtoexpense = false;
                        this.validMsg = "You have a less availabe budget."
                    }
                }).catch(response => {
                    console.log(response)
                    if (parseInt(this.expenses.amount) <= this.validAmount) {
                        this.isvalidtoexpense = true;
                        this.validMsg = ""
                    }
                    else {
                        this.validMsg = "You have a less availabe budget."
                        this.isvalidtoexpense = false;
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .expense-card {
        padding: 20px;
        background-color: #f5f5f5;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .toolbar {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .actions {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        background-color: #e0e0e0;
        padding: 10px;
        display: flex;
        justify-content: flex-end;
    }

    .custom-save-button {
        color: white;
        background-color: #1976d2;
    }

    .custom-radio .v-input--selection-controls__input {
        display: none; /* Hide the default radio button */
    }

    .custom-radio .v-icon {
        font-size: 24px; /* Adjust the icon size */
        color: #ccc; /* Default icon color */
        transition: color 0.3s;
    }

    /* Apply different colors based on index */
    .custom-radio:nth-child(1) .v-icon {
        color: #FF5733;
    }

    .custom-radio:nth-child(2) .v-icon {
        color: #3A89F1;
    }

    .custom-radio:nth-child(3) .v-icon {
        color: #9C27B0;
    }

    .custom-textarea .v-input__control {
        border-color: #bdbdbd;
    }

    .custom-textarea .v-label {
        color: #757575;
        font-weight: 500;
        font-size: 14px;
    }

    .custom-textarea .v-input__icon--clear {
        color: #bdbdbd;
    }

    .custom-textarea textarea {
        font-size: 14px;
        color: #333;
        border: none;
        resize: vertical;
    }

        .custom-textarea textarea:focus {
            box-shadow: 0 0 0 2px #1976d2;
        }
</style>
